import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo/icon-512x512.png'


const _hoisted_1 = { class: "q-mt-sm" }

import { computed, onMounted, ref, watch, watchEffect } from "vue";
import { Auth, getAuth, onAuthStateChanged } from "firebase/auth";
import { useI18n } from "vue-i18n";
import {
  useAppSettingsStore,
  useAppStateStore,
  useCardStore,
  useConnectionStore,
  useDayCardStore,
  useDefaultGameSettingsStore,
  useGhostCardStore,
  usePriceStore,
  useTabStore,
  useUserStore,
} from "@/services/pinia.service";
import { cardService, CardStore } from "@/services/card.service";
import { Karte } from "@/models/Karte";
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { pricesService } from "@/services/prices.service";
import { useRouter } from "vue-router";
import { DayRoleCard } from "@/models/DayRoleCard";
import { ghostCardService } from "@/services/ghostCard.service";
import { GhostCard } from "@/models/GhostCard";
import { MyUser } from "@/models/MyUser";
import ImgTab from "@/features/display-components/ImgTab.vue";
import CantAccsessToolTip from "@/features/input-components/CantAccsessToolTip.vue";
import RefreshComponent from "@/features/options/RefreshComponent.vue";
import ToggleWithIcon from "@/features/input-components/ToggleWithIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const t = useI18n().t;
const cardStore = useCardStore();
const userStore = useUserStore();
const usePrice = usePriceStore();
const defaultGameSetting = useDefaultGameSettingsStore();
const appStateStore = useAppStateStore();
const router = useRouter();
const initDone = ref(false);
const loggedIn = ref(false);
const ghostCardStore = useGhostCardStore();
const tabStore = useTabStore();
const appSettingsStore = useAppSettingsStore();
const dayCardStore = useDayCardStore();
const appState = appStateStore.appState;
const dontPush = ref(false);
const touchStartX = ref<number | null>(null);
const touchStartY = ref<number | null>(null);
const settingsMenuOpened = ref(false);
const connectionStore = useConnectionStore();
connectionStore.monitorConnection();
cardStore.initializeCards();
userStore.initializeUser();
defaultGameSetting.initializeDefaultGameSettings();
appStateStore.initializeAppState();
dayCardStore.initializeCards();
ghostCardStore.initializeGhostCards();
tabStore.initializeTab();
appSettingsStore.initializeAppSettings();

watchEffect(() => {
  if (
    !connectionStore.isConnected &&
    router.currentRoute.value.name !== "playground-offline"
  ) {
    router.push("/create-game");
    tabStore.currentTab = "homeOwnerGame";
  }
});

const me = computed(() => userStore.getUser as MyUser);

const isLoggedIn = ref(false);
const $q = useQuasar();
let auth: Auth;
onMounted(() => {
  auth = getAuth();
  appStateStore.getAppState.showSearchBar = false;
  onAuthStateChanged(auth, (user) => {
    isLoggedIn.value = !!user;
    if (user && connectionStore.isConnected) {
      loggedIn.value = true;
      initBasicCards();
      initGhostCards();
      getPrices();
      navigateToPageOfLastSessionIfPossible();
    }
  });
});

auth = getAuth();
onAuthStateChanged(auth, (user) => {
  isLoggedIn.value = !!user;
  if (!user) {
    loggedIn.value = false;
  }
});

const showJoinAndCreateGameTab = computed<boolean>(() => {
  return (
    ["homePlayerYou", "homeOwnerGame"].includes(tabStore.currentTab) &&
    appStateStore.getAppState.game === undefined
  );
});

function navigateToTab() {
  if (dontPush.value) {
    dontPush.value = false;
    return;
  }
  switch (tabStore.currentTab) {
    case "homeOwnerGame":
      if (
        appStateStore.getAppState.homeRoute === "/" &&
        !appState.game &&
        connectionStore.isConnected
      ) {
        router.push("/create-game");
      } else {
        router.push(appStateStore.getAppState.homeRoute);
      }
      break;
    case "homePlayerYou":
      if (appStateStore.getAppState.homeRoute === "/" && !appState.game) {
        router.push("/join-game-lobby");
      } else {
        router.push(appStateStore.getAppState.homeRoute);
      }
      break;
    case "homeOwnerSettings":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerCardsPlayerView":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerCards":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerDayCards":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerVote":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerChurchWall":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerGhostChat":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerDayRole":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homePlayerCards":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homePlayerPlayers":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homePlayerChurchWall":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homePlayerGhostChat":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homePlayerVotingResult":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "homeOwnerNextNight":
      router.push(appStateStore.getAppState.homeRoute);
      break;
    case "cardDeck":
      setTabsCards();
      router.push("/card-deck");
      break;
    case "createCardBasic-dont-push":
      setTabsCards();
      dontPush.value = true;
      tabStore.currentTab = "createCardBasic";
      break;
    case "createCardBasic":
      setTabsCards();
      if (router.currentRoute.value.name !== "edit-card") {
        router.push("/create-card");
      }
      break;
    case "createCardEffects":
      setTabsCards();
      if (router.currentRoute.value.name !== "edit-card") {
        router.push("/create-card");
      }
      break;
    case "createCardPreview":
      setTabsCards();
      if (router.currentRoute.value.name !== "edit-card") {
        router.push("/create-card");
      }
      break;
    case "communityCards":
      setTabsCards();
      router.push("/community-cards");
      break;
    case "defaultGameSettings":
      router.push("/game-settings");
      break;
    case "profile":
      router.push("/profile");
      break;
    case "tutorials":
      router.push("/tutorials");
      break;
    case "appSettings":
      router.push("/app-settings");
      break;
  }
  tabStore.save();
}

function setTabsCards() {
  tabStore.setTabs(
    [
      router.currentRoute.value.name !== "edit-card" ? "cardDeck" : undefined,
      !me.value?.isAnonymous ? "createCardBasic" : undefined,
      !me.value?.isAnonymous ? "createCardEffects" : undefined,
      !me.value?.isAnonymous ? "createCardPreview" : undefined,
      !me.value?.isAnonymous && router.currentRoute.value.name !== "edit-card"
        ? "communityCards"
        : undefined,
    ].filter(Boolean) as string[]
  );
}

const noHomeTab = computed(() => {
  return ![
    "homeJoinGameLobby",
    "homeCreateGame",
    "homeOwnerSettings",
    "homeOwnerCardsPlayerView",
    "homeOwnerCards",
    "homeOwnerDayCards",
    "homeOwnerGame",
    "homeOwnerVote",
    "homeOwnerChurchWall",
    "homeOwnerDayRole",
    "homeOwnerGhostChat",
    "homeOwnerNextNight",
    "homePlayerCards",
    "homePlayerPlayers",
    "homePlayerChurchWall",
    "homePlayerGhostChat",
    "homePlayerVotingResult",
    "homePlayerYou",
  ].includes(tabStore.currentTab);
});

const noCardTab = computed(() => {
  return ![
    "cardDeck",
    "createCardBasic",
    "createCardBasic-dont-push",
    "createCardEffects",
    "createCardPreview",
    "communityCards",
  ].includes(tabStore.currentTab);
});

function navigateToAHomeTab() {
  if (noHomeTab.value) {
    tabStore.currentTab = "homePlayerYou";
  }
}

function navigateToACardTab() {
  if (noCardTab.value) {
    tabStore.currentTab = "cardDeck";
  }
}

function navigateToPageOfLastSessionIfPossible() {
  const route = appStateStore.appState.currentRoute;
  if (route && (route === "/" || route === "/login" || route === "/register")) {
    if (
      ["/playground-online", "/playground-offline"].includes(
        appStateStore.appState.lastRoute
      ) &&
      !localStorage.getItem("game")
    ) {
      initDone.value = true;
      return;
    }
    router.push(appStateStore.appState.lastRoute);
  }
  initDone.value = true;
}

function onTouchStart(e: TouchEvent) {
  touchStartX.value = e.touches[0].clientX;
  touchStartY.value = e.touches[0].clientY;
}

function onTouchMove(e: TouchEvent) {
  if (touchStartX.value === null || touchStartY.value === null) {
    return;
  }
  if (!noHomeTab.value) {
    return;
  }
  const touchEndX = e.touches[0].clientX;
  const touchEndY = e.touches[0].clientY;

  const diffX = touchEndX - touchStartX.value;
  const diffY = touchEndY - touchStartY.value;

  // Überprüfen, ob die horizontale Verschiebung groß genug ist
  if (Math.abs(diffX) > appSettingsStore.getAppSettings.swipeThreshold) {
    // Überprüfen, ob die horizontale Verschiebung größer ist als die vertikale
    if (Math.abs(diffX) > Math.abs(diffY)) {
      // Horizontaler Swipe
      e.preventDefault();
      if (diffX > 0) {
        tabStore.switchTab(true); // Rechts wischen
      } else {
        tabStore.switchTab(false); // Links wischen
      }
    }
  }

  touchStartX.value = null;
  touchStartY.value = null;
}

watchEffect(() => {
  if (initDone.value) {
    appStateStore.appState.currentPageTitle =
      (router.currentRoute.value.meta.title as string) ?? "home";
    appStateStore.appState.lastRoute = appStateStore.appState.currentRoute;
    appStateStore.appState.currentRoute = router.currentRoute.value.fullPath;
    appStateStore.save();
  }
});

watch(
  () => tabStore.currentTab,
  () => {
    navigateToTab();
  },
  { immediate: true }
);

async function initBasicCards() {
  try {
    const cards = (await cardService.getCards(
      CardStore.CARDS_STORE_PATH
    )) as Karte[];
    cards
      .filter((card: Karte) => card.basicKarte)
      .forEach((card: Karte) => {
        if (!cardService.isCardIdInList(card.id, cardStore.getCards)) {
          cardStore.addCard(card as Karte);
        }
      });
    const dayCards = await cardService.getCards(
      CardStore.DAY_ROLE_CARD_STORE_PATH
    );
    dayCards
      .filter((card: DayRoleCard) => card.basicKarte)
      .forEach((card: DayRoleCard) => {
        if (!cardService.isCardIdInList(card.id, dayCardStore.getCards)) {
          dayCardStore.addCard(card);
        }
      });
  } catch (error) {
    $q.notify({
      message: t("errorLoadingBasicCards"),
      type: "negative",
      position: "top",
      icon: "error",
    });
  }
}

async function initGhostCards() {
  try {
    const cards = await ghostCardService.getCards();
    cards.forEach((card: GhostCard) => {
      if (
        !ghostCardService.isCardIdInList(
          card.i18nKey,
          ghostCardStore.getDayRoleCards
        )
      ) {
        ghostCardStore.addCard(card);
      }
    });
  } catch (error) {
    $q.notify({
      message: t("errorLoadingBasicCards"),
      type: "negative",
      position: "top",
      icon: "error",
    });
  }
}

async function getPrices() {
  try {
    const prices = await pricesService.getPrices();
    usePrice.updatePrices(prices);
  } catch (error) {
    $q.notify({
      message: t("errorLoadingBasicCards"),
      type: "negative",
      position: "top",
      icon: "error",
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(RefreshComponent, { class: "no-select" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_layout, { view: "hHh lpr fFf" }, {
        default: _withCtx(() => [
          (me.value)
            ? (_openBlock(), _createBlock(_component_q_header, {
                key: 0,
                reveal: "",
                "reveal-offset": 5,
                class: "bg-red-10 text-white q-pt-xs",
                "height-hint": "58"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_toolbar, { class: "no-padding" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_toolbar_title, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateToAHomeTab())),
                        class: _normalizeClass(["text-white bg-secondary", {
              transparent: noHomeTab.value,
            }]),
                        style: {"border-radius":"0 2em 0 0","padding-bottom":"1px","height":"50px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_q_avatar, {
                              style: {"font-size":"32px"},
                              class: "q-ml-md"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_img, { src: _imports_0 })
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("appName")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_q_btn, {
                        disable: !_unref(connectionStore).isConnected,
                        icon: "style",
                        flat: "",
                        style: {"border-radius":"2em 2em 0 0","height":"50px"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateToACardTab())),
                        class: _normalizeClass(["text-white bg-secondary", {
              transparent: noCardTab.value,
            }])
                      }, null, 8, ["disable", "class"]),
                      _createVNode(_component_q_btn, {
                        icon: "more_vert",
                        flat: "",
                        disable: !_unref(connectionStore).isConnected,
                        style: {"border-radius":"2em 0 0 0","height":"50px"},
                        class: _normalizeClass(["text-white bg-secondary", {
              transparent: !settingsMenuOpened.value,
            }])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_menu, {
                            modelValue: settingsMenuOpened.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settingsMenuOpened).value = $event)),
                            style: {"z-index":"9999","border-radius":"0 0 0 2em"},
                            "max-width": "200px",
                            class: "bg-secondary text-white"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, null, {
                                default: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    to: "profile"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            class: "text-white",
                                            name: "account_circle"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("profile")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })), [
                                    [_directive_close_popup]
                                  ]),
                                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    to: "tutorials"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            class: "text-white",
                                            name: "school"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("tutorials")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })), [
                                    [_directive_close_popup]
                                  ]),
                                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    to: "game-settings",
                                    disable: me.value.isAnonymous
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            class: "text-white",
                                            name: "settings"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("defaultGameSettings")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disable"])), [
                                    [_directive_close_popup]
                                  ]),
                                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    to: "app-settings"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            class: "text-white",
                                            name: "settings"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("appSettings")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })), [
                                    [_directive_close_popup]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["disable", "class"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_header, {
                key: 1,
                elevated: "",
                class: "bg-red-10 text-white q-pt-xs"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_img, { src: _imports_0 })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: "/",
                            class: "text-white no-underline"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)("appName")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          _createVNode(_component_q_page_container, {
            class: _normalizeClass({ 'no-padding': _unref(router).currentRoute.value.fullPath === '/' }),
            onTouchstart: onTouchStart,
            onTouchmove: onTouchMove
          }, {
            default: _withCtx(() => [
              (me.value)
                ? (_openBlock(), _createBlock(_component_q_page_sticky, {
                    key: 0,
                    expand: "",
                    class: "z-99",
                    position: "top"
                  }, {
                    default: _withCtx(() => [
                      (showJoinAndCreateGameTab.value)
                        ? (_openBlock(), _createBlock(_component_q_tabs, {
                            key: 0,
                            dense: "",
                            modelValue: _unref(tabStore).currentTab,
                            "onUpdate:modelValue": [
                              _cache[3] || (_cache[3] = ($event: any) => ((_unref(tabStore).currentTab) = $event)),
                              _cache[4] || (_cache[4] = ($event: any) => (navigateToTab()))
                            ],
                            "no-caps": "",
                            class: "text-white full-width tab-secondary",
                            "active-class": "tab-secondary--active"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tab, {
                                name: "homePlayerYou",
                                class: "text-capitalize col-6",
                                icon: "wifi",
                                label: _unref(t)('joinAGame'),
                                disable: !_unref(connectionStore).isConnected
                              }, null, 8, ["label", "disable"]),
                              _createVNode(ImgTab, {
                                "tab-name": "homeOwnerGame",
                                "i18n-key": "createAGame",
                                class: "col-6",
                                img: "appLogo"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (
              [
                'cardDeck',
                'createCard',
                'communityCards',
                'createCardBasic',
                'createCardEffects',
                'createCardPreview',
              ].includes(_unref(tabStore).currentTab)
            )
                        ? (_openBlock(), _createBlock(_component_q_toolbar, {
                            key: 1,
                            class: "full-width bg-secondary no-padding text-white"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item, {
                                class: "no-padding full-width",
                                disable: _unref(router).currentRoute.value.name === 'edit-card'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tabs, {
                                    dense: "",
                                    modelValue: _unref(tabStore).currentTab,
                                    "onUpdate:modelValue": [
                                      _cache[6] || (_cache[6] = ($event: any) => ((_unref(tabStore).currentTab) = $event)),
                                      _cache[7] || (_cache[7] = ($event: any) => (navigateToTab()))
                                    ],
                                    "no-caps": "",
                                    class: "tab-secondary full-width",
                                    "active-class": "tab-secondary--active"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, {
                                        side: "",
                                        class: "q-px-lg"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_label, {
                                            class: "text-white flex flex-center",
                                            style: {"margin":"0 auto"},
                                            overline: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_icon, {
                                                name: 
                        _unref(appStateStore).getAppState.dayRoleCardView
                          ? 'light_mode'
                          : 'dark_mode'
                      ,
                                                size: "2em"
                                              }, null, 8, ["name"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_item_label, null, {
                                            default: _withCtx(() => [
                                              _createVNode(ToggleWithIcon, {
                                                dense: true,
                                                disable: _unref(router).currentRoute.value.name === 'edit-card',
                                                modelValue: _unref(appStateStore).getAppState.dayRoleCardView,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(appStateStore).getAppState.dayRoleCardView) = $event))
                                              }, null, 8, ["disable", "modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(ImgTab, {
                                            "tab-name": "cardDeck",
                                            "i18n-key": "cardDeck",
                                            class: "col-4",
                                            img: "karten",
                                            disabled: _unref(router).currentRoute.value.name === 'edit-card'
                                          }, null, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_tab, {
                                            name: 
                      _unref(tabStore).currentTab === 'createCardBasic'
                        ? 'createCardBasic'
                        : _unref(tabStore).currentTab === 'createCardEffects'
                        ? 'createCardEffects'
                        : _unref(tabStore).currentTab === 'createCardPreview'
                        ? 'createCardPreview'
                        : 'createCardBasic'
                    ,
                                            label: _unref(t)('createCard'),
                                            class: "text-capitalize col-4",
                                            icon: "edit_square",
                                            disable: me.value.isAnonymous
                                          }, {
                                            default: _withCtx(() => [
                                              (me.value.isAnonymous)
                                                ? (_openBlock(), _createBlock(CantAccsessToolTip, {
                                                    key: 0,
                                                    "because-anonymous": true
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["name", "label", "disable"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_tab, {
                                            name: "communityCards",
                                            label: _unref(t)('communityCards'),
                                            class: "text-capitalize col-4",
                                            icon: "cloud_download",
                                            disable: 
                      me.value.isAnonymous ||
                      _unref(router).currentRoute.value.name === 'edit-card'
                    
                                          }, {
                                            default: _withCtx(() => [
                                              (me.value.isAnonymous)
                                                ? (_openBlock(), _createBlock(CantAccsessToolTip, {
                                                    key: 0,
                                                    "because-anonymous": true
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["label", "disable"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["disable"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_router_view)
            ]),
            _: 1
          }, 8, ["class"]),
          (!me.value)
            ? (_openBlock(), _createBlock(_component_q_footer, {
                key: 2,
                class: "row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "col-3 text-center text-white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("home")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "impressum",
                    class: "col-4 text-center text-white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("impressum")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "datenschutz",
                    class: "col-5 text-center text-white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("privacyPolicy")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})